import Box from '@mui/material/Box';
import React from 'react';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import ContentCard from '../components/Cards/ContentCard';
import { useTranslation } from '../hook/Translation';


export default function EmfusionTransDermalInfusionFacial() {
const { t } = useTranslation();
    const data = [
        {
            header: t('face'),
            description: t('emfusion_trans_dermal_infusion_facial.faceDesc'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('neck'),
            description: t('emfusion_trans_dermal_infusion_facial.neckDesc'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('deolletage'),
            description: t('emfusion_trans_dermal_infusion_facial.decolletageDesc'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 19.png`,
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        }
    ]

    const accodirons = [
        {
            title: t('what'),
            content:t('emfusion_trans_dermal_infusion_facial.what'),
        },
        {
            title: t('how'),
            content:t('emfusion_trans_dermal_infusion_facial.how'),
        },
    ];

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('emfusion_trans_dermal_infusion_facial.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('emfusion_trans_dermal_infusion_facial.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('emfusion_trans_dermal_infusion_facial.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('emfusion_trans_dermal_infusion_facial.sessions'),
        }
    ];

    const TextBtnSectionData = {
        type: t('skinTherapies'),
        title: t('emfusion_trans_dermal_infusion_facial.mainTitle'),
        description: t('emfusion_trans_dermal_infusion_facial.mainDesc'),
        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Emfusion - Hidratim i thellë i lëkurës me infuzion transdermal")}`,
        price: `${t('price_session')} €170`,
        doctorIncluded: true
    };

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Emfusion_Girl_Main_L.png`} width={1} height={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection data={TextBtnSectionData} titleSize={{ md: 8, xs: 12 }} descriptionSize={{ md: 9, xs: 12 }} />
            </Box>

            <Box marginTop={{md: '107px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{md: '104px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: {md: '90px', xs: '50px'} }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Emfusion - Hidratim i thellë i lëkurës me infuzion transdermal")}`,
                            type: t('emfusion_trans_dermal_infusion_facial.tech'),
                            // learn: '/',
                            title: t('emfusion_trans_dermal_infusion_facial.techTitle'),
                            size: { md: 8, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageSize: {md: 4, xs: 12},
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/mages/2026/01/ALMA-2.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('emfusion_trans_dermal_infusion_facial.techDesc')
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '56px', xs: '30px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '90px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid bgcolor={'#F0F0EF'} marginTop={{md: '136px', xs: '50px'}} className="generalContainer" marginX={'auto'} container paddingY={{md: '80px', xs: '20px'}} paddingX={{md: '103px', xs: '20px'}} gap={'20px'}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontWeight={600} fontSize={{md: '1.125rem', xs: '1rem'}} color="text.secondary">{t('emfusion_trans_dermal_infusion_facial.results2Title')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontWeight={600} fontSize={{md: '1.875rem', xs: '1.5rem'}} color="text.secondary">{t('emfusion_trans_dermal_infusion_facial.results2Desc')}</Typography>
                </Grid>
            </Grid>

            <Grid container gap={{md: '52px', xs: '40px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '90px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600}>{t('emfusion_trans_dermal_infusion_facial.treatment_zone_title')}</Typography>
                    <Typography textAlign={'center'} marginX={'auto'} marginTop={'22px'} width={{md: '994px', xs: '100%'}} variant="body1" color="text.secondary" fontSize={'1rem'} fontWeight={600}>{t('emfusion_trans_dermal_infusion_facial.treatment_zone_desc')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} />
                </Grid>
            </Grid>

            <Box bgcolor={'#DBDAD9'} marginTop={{ md: '123px', xs: '50px' }} paddingTop={{ md: '120px', xs: '50px' }} paddingBottom={{ md: '188px', xs: '50px' }}>
                <Box className="generalContainer" marginX={'auto'} gap={'89px'} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08ee94c4506.97198974.jpg`,
                            type: t('pairing'),
                            title: t('emfusion_trans_dermal_infusion_facial.cardTitle'),
                            description: t('emfusion_trans_dermal_infusion_facial.card1Desc'),
                            direction: { md: 'row-reverse', xs: 'column-reverse' },
                            learn: "/body/exion-rf-body-skin-tightening",
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION BODY")}`
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box>
        </Box>
    )
}